import { instance } from '../download';

export const downloadPackage = (param) => instance.post('jarpackage/download', param);
